import React from "react";
import { View, StyleSheet, ActivityIndicator, Text, Platform } from "react-native";

import htmlContent from "./h5/html";
import injectedSignaturePad from "./h5/js/signature_pad";
import injectedApplication from "./h5/js/app";
import injectedHeadJavascript from "./h5/js/headJs";

import { WebView } from "react-native-webview";

const styles = StyleSheet.create({
  webBg: {
    width: "100%",
    backgroundColor: "#FFF",
    flex: 1
  },
  loadingOverlayContainer: { position: "absolute", top: 0, bottom: 0, left: 0, right: 0, alignItems: "center", justifyContent: "center" },
});

class SignatureView extends React.Component {

  state = { loading: Platform.OS !== "web" }
  source = ""
  webviewRef = { current: null } //no idea why but createRef doesnt work
  constructor(props) {
    super(props)
    const {
      webStyle = "",
      descriptionText = "Sign above",
      clearText = "Clear",
      confirmText = "Confirm",
      customHtml = null,
      autoClear = false,
      trimWhitespace = false,
      imageType = "image/png",
      dataURL = "",
      penColor = "",
      backgroundColor = "",
      dotSize = 0,
      minWidth = 0.5
    } = props

    let injectedJavaScript = injectedSignaturePad + injectedApplication;
    const htmlContentValue = customHtml ? customHtml : htmlContent;
    injectedJavaScript = injectedJavaScript.replace("<%autoClear%>", autoClear);
    injectedJavaScript = injectedJavaScript.replace("<%trimWhitespace%>", trimWhitespace);
    injectedJavaScript = injectedJavaScript.replace("<%imageType%>", imageType);
    injectedJavaScript = injectedJavaScript.replace("<%dataURL%>", dataURL);
    injectedJavaScript = injectedJavaScript.replace("<%penColor%>", penColor);
    injectedJavaScript = injectedJavaScript.replace("<%backgroundColor%>", backgroundColor);
    injectedJavaScript = injectedJavaScript.replace("<%dotSize%>", dotSize);
    injectedJavaScript = injectedJavaScript.replace("<%minWidth%>", minWidth);

    let html = htmlContentValue(injectedJavaScript);
    html = html.replace("<%headjs%>",injectedHeadJavascript );
    html = html.replace("<%style%>", webStyle);
    html = html.replace("<%description%>", descriptionText);
    html = html.replace("<%confirm%>", confirmText);
    html = html.replace("<%clear%>", clearText);

    this.source = { html }

    this.readSignature = this.readSignature.bind(this)
    this.clearSignature = this.clearSignature.bind(this)

  }

  setLoading = (val) => {
    this.setState({ loading: val })
  }
  readSignature = () => {
    if (this.webViewRef) {
      if (Platform.OS === "web") {
        this.webViewRef.postMessage("READ_SIG", "*")
      }
      else {
        this.webViewRef.injectJavaScript("readSignature();true;");
      }
    }
  }
  clearSignature = () => {
    if (this.webViewRef) {
      if (Platform.OS === "web") {
        this.webViewRef.postMessage("CLEAR_SIG", "*")
      }
      else {
        this.webViewRef.injectJavaScript("clearSignature();true;");
      }
    }
  }

  renderError = (e) => {
    const { nativeEvent } = e;
    console.warn("WebView error: ", nativeEvent);

  }

  getSignature = e => {
    const {
      onOK = () => { },
      onEmpty = () => { },
      onClear = () => { },
      onBegin = () => { },
      onEnd = () => { } } = this.props

    switch (e.nativeEvent.data) {
      case "BEGIN":
        onBegin();
        break;
      case "END":
        onEnd();
        break;
      case "EMPTY":
        onEmpty();
        break;
      case "CLEAR":
        onClear();
        break;
      default: {
        if (typeof e.nativeEvent.data === "string")
          onOK(e.nativeEvent.data);
      }
    }
  };

  render() {
    return <View style={styles.webBg}>
      <WebView
        bounces={false}
        androidHardwareAccelerationDisabled={this.props.androidHardwareAccelerationDisabled}
        ref={(ref) => { this.webViewRef = ref }}
        useWebKit={true}
        source={this.source}
        onMessage={this.getSignature}
        javaScriptEnabled={true}
        onError={this.renderError}
        onLoadEnd={() => this.setLoading(false)}
      />
      {this.state.loading && <View style={styles.loadingOverlayContainer}>
        <ActivityIndicator />
      </View>}
    </View>
  }
}

export default SignatureView;
